import Tooltip from '@pelckmans/elementis/components/tooltip';
import { cloneElement, ReactNode } from 'react';
import useIsMobile from '../../hooks/useIsMobile';

interface Props {
  id: string;
  /**
   * The pill element to which the tooltip will be anchored.
   * The tooltip property will be cloned onto this element.
   */
  pill: ReactNode;
  tooltipContent: ReactNode;
  persistTooltip?: boolean;
}

function MethodModuleStatus({ id, pill, tooltipContent, persistTooltip }: Props) {
  const isMobile = useIsMobile();

  if (isMobile && !persistTooltip) return pill;

  return (
    <Tooltip
      key={id}
      truncation="wrapped"
      anchor={cloneElement(pill as React.ReactElement<{ tooltip?: boolean }>, { tooltip: true })}
    >
      {tooltipContent}
    </Tooltip>
  );
}

export default MethodModuleStatus;
